import type { FastagProfile, QualificationState } from '../types';

export function getQualificationState(profile: FastagProfile): QualificationState {
  if (!profile.linked) return 'unqualified';
  if (profile.balance < 0 || profile.recentDecline) return 'negative';
  if (profile.balance < 100) return 'low';
  if (profile.predictedLow) return 'predicted-low';
  return 'unqualified';
}

export function isQualified(profile: FastagProfile): boolean {
  return getQualificationState(profile) !== 'unqualified';
}

export function computeRecommendedAmount(balance: number): number {
  if (balance < 0) {
    return Math.min(500, Math.ceil((500 - balance) / 50) * 50);
  }
  return Math.min(500, Math.ceil((500 - balance) / 50) * 50);
}
